const ENDPOINTS_CONFIG_FILE_NAME = {
  LOCAL: 'localEndpointStub.json',
  DEV: 'devEndpointStub.json',
  INT: 'intEndpointStub.json',
  UAT: 'uatEndpointStub.json',
  PROD: 'proEndpointStub.json',
}

const ENVIRONMENT_FILE_NAME = 'envstub.json'

const COMUNNICATION_CONFIG_LANGUAGE =
  'Communication config must have a "language" with verb "get" for i18n service'

const COMMUNICATION_CONFIG_AUTH =
  'Communication config must have a "auth" with verb "post" for auth service'

export {
  ENDPOINTS_CONFIG_FILE_NAME,
  COMUNNICATION_CONFIG_LANGUAGE,
  COMMUNICATION_CONFIG_AUTH,
  ENVIRONMENT_FILE_NAME,
}
